/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Nfp_Doc_UploadedInputs */

const en_msg_nfp_doc_uploaded = /** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded. Our team will review it shortly.`)
};

const es_msg_nfp_doc_uploaded = /** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento subido. Nuestro equipo lo revisará en breve.`)
};

const fr_msg_nfp_doc_uploaded = /** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document téléchargé. Notre équipe l'examinera sous peu.`)
};

const de_msg_nfp_doc_uploaded = /** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument hochgeladen. Unser Team wird es in Kürze prüfen.`)
};

const id_msg_nfp_doc_uploaded = /** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen diunggah. Tim kami akan segera meninjaunya.`)
};

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const ja_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const zh_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const ar_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const it_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const ru_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const pt_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/** @type {(inputs: Msg_Nfp_Doc_UploadedInputs) => LocalizedString} */
const ko_msg_nfp_doc_uploaded = en_msg_nfp_doc_uploaded;

/**
* | output |
* | --- |
* | "Document uploaded. Our team will review it shortly." |
*
* @param {Msg_Nfp_Doc_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_nfp_doc_uploaded = /** @type {((inputs?: Msg_Nfp_Doc_UploadedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Nfp_Doc_UploadedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_nfp_doc_uploaded(inputs)
	if (locale === "es") return es_msg_nfp_doc_uploaded(inputs)
	if (locale === "fr") return fr_msg_nfp_doc_uploaded(inputs)
	if (locale === "de") return de_msg_nfp_doc_uploaded(inputs)
	if (locale === "ja") return ja_msg_nfp_doc_uploaded(inputs)
	if (locale === "zh") return zh_msg_nfp_doc_uploaded(inputs)
	if (locale === "ar") return ar_msg_nfp_doc_uploaded(inputs)
	if (locale === "id") return id_msg_nfp_doc_uploaded(inputs)
	if (locale === "it") return it_msg_nfp_doc_uploaded(inputs)
	if (locale === "ru") return ru_msg_nfp_doc_uploaded(inputs)
	if (locale === "pt") return pt_msg_nfp_doc_uploaded(inputs)
	return ko_msg_nfp_doc_uploaded(inputs)
});